import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';
import api from '../../Axios/middleware';
import { failureGetSpecialDay, successGetSpecialDay } from './SpecialDaySlicer';
import { ISpecialDayList } from '../../../Pages/Pricing/IPricing';
import { PayloadAction } from '@reduxjs/toolkit';
import {
  failureAddSpecialDay,
  successAddSpecialDay,
} from './AddSpecialDaySlicer';
import {
  failureUpdateSpecialDay,
  successUpdateSpecialDay,
} from './UpdateSpecialDaySlicer';
import {
  failureDeleteSpecialDay,
  successDeleteSpecialDay,
} from './DeleteSpecialDaySlice';
import { Phone } from '@mui/icons-material';

const SpecialDayApi = (action: PayloadAction<any>) => {
  return api.get(`/special-days/${action.payload}`);
};

export function* SpecialDayCall(action: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(SpecialDayApi, action);
    yield put(successGetSpecialDay(response.data));
  } catch (error) {
    yield put(failureGetSpecialDay(error));
  }
}

// add SpecialDay
const AddSpecialDayApi = (action: PayloadAction<ISpecialDayList>) => {
  const data = {
    // first_name: action.payload.first_name,
    // last_name: action.payload.first_name,
    // email: action.payload.email,
    // Phone: action.payload.phone,
    // status: action.payload.status,
  };

  return api.post('special-days/create', action.payload);
};

export function* AddSpecialDayCall(action: PayloadAction<ISpecialDayList>) {
  try {
    const response: AxiosResponse = yield call(AddSpecialDayApi, action);
    yield put(successAddSpecialDay(response.data));
  } catch (error) {
    yield put(failureAddSpecialDay(error));
  }
}

// update SpecialDay
const UpdateSpecialDayApi = (action: PayloadAction<ISpecialDayList>) => {
  const url = `/special-days/${action.payload.id}`;

  return api.patch(url, action.payload);
};

export function* UpdateSpecialDayCall(action: PayloadAction<ISpecialDayList>) {
  try {
    const response: AxiosResponse = yield call(UpdateSpecialDayApi, action);
    yield put(successUpdateSpecialDay(response.data));
  } catch (error) {
    yield put(failureUpdateSpecialDay(error));
  }
}

// delete SpecialDay
const DeleteSpecialDayApi = (action: PayloadAction<number>) => {
  return api.delete(`/special-days/${action.payload}`);
};
export function* DeleteSpecialDayCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteSpecialDayApi, action);
    yield put(successDeleteSpecialDay(response.data));
  } catch (error) {
    yield put(failureDeleteSpecialDay(error));
  }
}
